module.exports = __webpack_public_path__ + "fonts/Lyon Arabic Display Bold.8a951df.otf";